import { useIsStoreNotWithinDeliveryDistance } from 'hooks/useIsStoreWithinDeliveryDistance';
import { useSelector } from 'react-redux';
import { selectors } from 'redux/app/app.slice';
import { makeSelectIsMenuBrowsingStore } from 'redux/locations/locations.selectors';
import { CATERING } from 'util/constants';

export const useLocationsMapIsGrayOut = store => {
  const isMenuBrowsingStore = useSelector(
    makeSelectIsMenuBrowsingStore(store.storeId),
  );

  const locationType = useSelector(selectors.selectLocationsLocationType);
  const isStoreNotWithinDeliveryDistance =
    useIsStoreNotWithinDeliveryDistance(store);

  if (isMenuBrowsingStore) return false;

  if (locationType === CATERING)
    return !store.pickupOrdersAccepted && !store.deliveryOrdersAccepted;

  return (
    isStoreNotWithinDeliveryDistance ||
    (!store.pickupOrdersAccepted && !store.deliveryOrdersAccepted)
  );
};
